"use strict";

export function initInScope($scope) {
    let selectTopicsWrapper = $scope.find('.js-select-topics');

    selectTopicsWrapper.on('change', '.select-topic--visible:last()', function () {
        selectTopicsWrapper.find('.select-topic--hidden:first()').removeClass('select-topic--hidden').addClass('select-topic--visible');
    });
}